export enum TypeOfClassroomBasedOnEnrollments {
	Individual = "INDIVIDUAL",
	Group = "GROUP"
}
